// import { Capacitor } from "@capacitor/core";
// import { SplashScreen } from '@capacitor/splash-screen';

import appParameters, { CONTEXT_WEBSITE, CONTEXT_MOBILE_APP } from '@/core/config/parameters';

const { APP_CONTEXT } = appParameters;

export default {
  // /**
  //  * Detects native mobile platform
  //  * @returns {*}
  //  */
  // isMobilePlatform() {
  //   return Capacitor.isNativePlatform();
  // },

  /**
   * Detects mobile context declaration set in core/config/parameters.js
   * @returns {boolean}
   */
  isMobileContext() {
    return APP_CONTEXT === CONTEXT_MOBILE_APP;
  },

  /**
   * Detects web context declaration set in core/config/parameters.js
   * @returns {boolean}
   */
  isWebContext() {
    return APP_CONTEXT === CONTEXT_WEBSITE;
  },

  // async hideNativeSplashScreen() {
  //   await SplashScreen.hide();
  // }
};
